import { Flex } from "@biblioteksentralen/react";
import { getPath, ResolvedDigitalLibraryServiceSummary } from "@libry-content/common";
import { DigitalLibraryServiceCategory } from "@libry-content/types";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { ServiceCategoryIcon } from "./ServiceCategoryIcon";
import { CommonServicePreview } from "./CommonServicePreview";
import { useDigitalServiceColor } from "./useDigitalServiceColor";

type DigitalLibraryServicePreviewDesktopProps = {
  digitalLibraryService: ResolvedDigitalLibraryServiceSummary;
  category: DigitalLibraryServiceCategory;
};

export const DigitalLibraryServicePreviewDesktop = ({
  digitalLibraryService,
  category,
}: DigitalLibraryServicePreviewDesktopProps) => {
  const { ts } = useTranslation();
  const iconColor = useDigitalServiceColor(digitalLibraryService);

  return (
    <CommonServicePreview
      image={digitalLibraryService.image}
      imagePlaceholder={
        <Flex {...iconColor?.css}>
          <ServiceCategoryIcon margin="auto" width="4.5rem" height="4.5rem" category={category} background="none" />
        </Flex>
      }
      heading={ts(digitalLibraryService.name)}
      teaser={ts(digitalLibraryService.teaser)}
      href={getPath(digitalLibraryService)}
      doc={digitalLibraryService}
    />
  );
};
